var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.innerValue}},'select',_vm.$attrs,false),{
    ..._vm.$listeners,
    input: _vm.onInput,
  }),[_vm._t("default",function(){return _vm._l((_vm.options),function(opt,i){return _c('option',{key:i,attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.optionInnerValue(opt)}},[_vm._v(" "+_vm._s(opt[_vm.optionLabel])+" ")])})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }